import React, { useState } from 'react';
import { Download, FileText } from 'lucide-react';
import { api } from '../../services/api';

interface ReportExportProps {
  scanId: string;
}

export const ReportExport: React.FC<ReportExportProps> = ({ scanId }) => {
  const [downloading, setDownloading] = useState<string | null>(null);

  const handleDownload = async (format: 'pdf' | 'json' | 'md') => {
    setDownloading(format);
    try {
      const blob = await api.downloadScanReport(scanId, format);
      const extensions = { pdf: 'pdf', json: 'json', md: 'md' };
      api.saveScanReport(blob, `compliance-report-${scanId}.${extensions[format]}`);
    } catch (error) {
      console.error('Download failed:', error);
    } finally {
      setDownloading(null);
    }
  };

  return (
    <div style={{ display: 'flex', gap: 'var(--space-2)', flexWrap: 'wrap' }}>
      <button
        onClick={() => handleDownload('pdf')}
        disabled={downloading !== null}
        className="btn btn-secondary btn-sm"
      >
        <Download size={16} />
        {downloading === 'pdf' ? 'Downloading...' : 'PDF Report'}
      </button>
      <button
        onClick={() => handleDownload('json')}
        disabled={downloading !== null}
        className="btn btn-secondary btn-sm"
      >
        <FileText size={16} />
        {downloading === 'json' ? 'Downloading...' : 'JSON'}
      </button>
      <button
        onClick={() => handleDownload('md')}
        disabled={downloading !== null}
        className="btn btn-secondary btn-sm"
      >
        <FileText size={16} />
        {downloading === 'md' ? 'Downloading...' : 'Markdown'}
      </button>
    </div>
  );
};

export default ReportExport;
